<template>
  <div>
    <div class="row mb-2">
      <div class="col">
        <form action="" class="form-inline" v-on:submit="ws">
          <div class="form-group mr-3">
            <label for="message" class="sr-only">Message</label>
            <input id="message" v-model="message" type="text" class="form-control" placeholder="Message">
          </div>
          <button type="submit" class="btn btn-primary">Send</button>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <WsLogTable v-bind:logs="textLog" />
      </div>
    </div>
  </div>
</template>

<script>
  import {Client} from '@stomp/stompjs'
  import WsLogTable, {LogItem} from "./WsLogTable.vue"

  export default {
    name: 'WebsocketDemo',
    components: {
      WsLogTable
    },
    props: {},
    data: () => {
      return {
        textLog: [],
        message: ''
      }
    },
    created() {
      this.client = new Client({brokerURL: 'ws://localhost:8081/gs-guide-websocket'})
      this.client.onConnect = () => {
        this.addMessage('Info', 'Connected to WS')
        this.subscription = this.client.subscribe('/topic/greetings', message =>
            this.addMessage('Incoming', JSON.parse(message.body).content)
        )
        this.client.subscribe('/topic/errors', message =>
            this.addMessage('Error', message.body)
        )
        this.client.subscribe('/user/queue/reply', message =>
            this.addMessage('Private', JSON.parse(message.body).content)
        )
      }
      this.client.onStompError = frame => this.addMessage('Error', 'Stomp error: ' + frame)
      this.client.onWebSocketError = event => this.addMessage('Error', 'WebSocket error: ' + JSON.stringify(event))
      this.client.activate()
      this.counter = 1
    },
    beforeDestroy() {
      this.subscription.unsubscribe()
    },
    methods: {
      ws(event) {
        this.client.publish({destination: '/app/hello', body: JSON.stringify({name: this.message})})
        this.client.publish({destination: '/app/helloMe', body: JSON.stringify({name: 'kovács'})})
        event.preventDefault()
      },
      addMessage(type, message) {
        this.textLog.push(new LogItem(this.counter++, type, message))
      }
    }
  }
</script>
